var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcStarly2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "m4s44r5lba",
    cx: 21,
    cy: 21,
    r: 21
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b63uosyr1b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m4s44r5lba"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b63uosyr1b)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 21,
    cy: 21,
    r: 21
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.757 19.93 2.137 2.097 2.129 2.134v6.797h-2.13v-7.316L12.49 31H11v-1.54l7.434-7.433H11v-2.096h6.757zM22.023 11l-.001 7.44L29.51 11H31v1.54l-7.391 7.39H31v2.097h-6.757l-1.379-1.352-.01.01-.832-.831.001.077-2.13-2.134V11h2.13z",
    fill: "#FFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStarly2);
export default __webpack_public_path__ + "static/media/ic-starly2.52b656f83b66d488c139850c6892c55b.svg";
export { ForwardRef as ReactComponent };